import CalloutRepository from "../CalloutRepository"

export default class FeatureCallout extends CalloutRepository {
    static schemaId = "feature_callout1"

    constructor() {
        super(FeatureCallout.schemaId)
    }
}
